module.exports = __webpack_public_path__ + "assets/img/1711589512664_.pic_hd.7cae2fbb.jpg";